import { DealStatus } from "@irati/types";
export var isDealUnavailable = function (deal) {
    return deal.status === DealStatus.Unavailable;
};
